/** WhatsApp messages and enrolments carry international digits without the plus (447700900123); customers carry the plus. */
export function formatWhatsAppNumber(digits: string | null | undefined): string | null {
  return digits ? `+${digits}` : null;
}
